export const currencyFormatter = Intl.NumberFormat('pt-BR', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});
export const numberFormatter = new Intl.NumberFormat('pt-BR');
